import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  Btn,
  CustomDataTableHeader,
  CustomPanel,
  ExcelModeloBuilder,
  ImportExcelFile,
  PageHeader,
  Periodo,
  ThreeDots,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import useMovimentacaoRecebimento, {
  LOAD_MESSAGE,
  MODEL_EXCEL,
} from './MovimentacaoRecebimentoHook'
import MovimentacaoRecebimentoModal from './MovimentacaoRecebimentoModal/MovimentacaoRecebimentoModal'

function MovimentacaoRecebimento({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useMovimentacaoRecebimento()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_RECEIPTS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getMovimentacoesRecebimento(
          state.periodo.dataInicial,
          state.periodo.dataFinal,
          selectedTp,
        )
        break

      case LOAD_MESSAGE.FILTERING:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getMovimentacoesRecebimento(
          state.periodo.dataInicial,
          state.periodo.dataFinal,
          selectedTp,
        )
        break

      case LOAD_MESSAGE.SALVAR_IMPORTACAO:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.salvarImport(state.recebimentoImportacao)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <>
      <PageHeader>6.2 - Movimentação - Recebimento</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={() => localDispatch.onNovoClick(selectedTp)} onVoltar={history.goBack}>
          <div className="p-grid p-align-end">
            <div className="p-col-3">
              <Periodo
                periodoInicial={state.periodo.dataInicial}
                periodoFinal={state.periodo.dataFinal}
                onPesquisar={localDispatch.onBtnPesquisarClick}
              />
            </div>
            <div className="p-col-6" style={{ display: 'inline-block', marginLeft: 10 }}>
              <Btn
                onClick={() => localDispatch.onBtnExportarExcel(state.movimentacoes)}
                style={{ marginRight: 10 }}
              >
                Exportar Excel Recebimento
              </Btn>
              <ExcelModeloBuilder
                modeloColunas={MODEL_EXCEL}
                filename="ImportacaoRecebimento.xlsx"
              />
              <div style={{ display: 'inline-block', marginLeft: 10 }}>
                <ImportExcelFile
                  label="Importar Excel Recebimento"
                  classes="btnImportar"
                  onFileImported={content => localDispatch.onFileImported(content, selectedTp)}
                />
              </div>
            </div>
            <div className="p-col-12">
              <DataTable
                value={state.movimentacoes}
                emptyMessage={'Não existe movimentação para o Período selecionado'}
                paginator={true}
                rows={10}
                header={<CustomDataTableHeader onChange={localDispatch.onGlobalFilterChange} />}
                globalFilter={state.globalFilter}
              >
                <Column field={'id'} header={'Código'} style={tableCellCentered(80)} />
                <Column
                  field="data_movimentacao"
                  header="Criada em"
                  style={tableCellCentered()}
                  body={mov =>
                    typeof mov.data_movimentacao === 'string'
                      ? mov.data_movimentacao
                      : mov.data_movimentacao.toLocaleDateString()
                  }
                />
                <Column field={'placa'} header={'Placa'} style={tableCellCentered(120)} />
                <Column
                  field={'nome_transportadora'}
                  header={'Transportadora'}
                  style={tableCellCentered(120)}
                />
                <Column
                  header={'#'}
                  body={item => (
                    <ThreeDots
                      items={['Editar', 'Emitir Comprovante', 'Upload Comprovante']}
                      onClick={menuItem => localDispatch.onMenuItemClick(menuItem, item, history)}
                    />
                  )}
                  style={tableCellCentered(80)}
                />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
      <MovimentacaoRecebimentoModal modal={state.modal} onResponse={localDispatch.onModalEvent} />
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })

export default connect(mapStateToProps)(withRouter(MovimentacaoRecebimento))
